import * as address from './address.js';
import * as anchor from './anchor.js';
import * as button from './button.js';
import * as dialog from './dialog.js';
import * as figure from './figure.js';
import * as hr from './hr.js';
import * as image from './image.js';
import * as input from './input.js';
import * as list from './list.js';
import * as screenReader from './screen-reader.js';
import * as text from './text.js';
import * as touch from './touch.js';

/**
 * Merges all resets into a single className which can be applied to any
 * element.
 *
 * When applied then all elements below will have the resets applied with a
 * specificity of 0, meaning that any custom styles will always take precedence
 * over our resets
 */
const rootCls = "resets--root";

/**
 * Expose all individual resets as well as our root className which merges the
 * resets, allowing consumers full control over the exact reset that they may
 * need
 */
const resets = {
  ...address,
  ...anchor,
  ...button,
  ...dialog,
  ...hr,
  ...input,
  ...text,
  ...list,
  ...image,
  ...figure,
  ...touch,
  ...screenReader,
  rootCls
};

export { resets };
import "./index.linaria.module.css";
//# sourceMappingURL=index.js.map
